module.exports = __webpack_public_path__ + "img/service.b2e62c3c.png";